<template>
    <div>
        <section v-if="paso1" class="padding-vertical-content white-content right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + manager.bg2_url + ")"'></div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6 col-xl-5">
                                <div v-if="loading">
                                    <LoaderComponent/>
                                </div>
                                <h2 class="m-0 mt-5 h1 text-uppercase">{{ $t('renovar_abono.renueva_abono', {abono: teatro.texto_abono}) }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5"> {{ $t('renovar_abono.temporada', { temporada: lista_abonados.nombre }) }}</div>

                                <BuscarAbonadoComponent :abonado="abonado_search" v-on:terminado="buscarAbonado"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="padding-vertical-content" v-if="abonado">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="h2 mb-3 mb-lg-4 d-block">{{ $t('renovar_abono.tus_datos') }}</div>
                        <div class="lightgray-content p-2 p-lg-3 w-100 mb-4">
                            <InformacionAbonadoComponent :abonado="abonado" :asiento="asiento"/>
                        </div>
                    </div>
                    <div class="col-12">
                        <div v-if="paso3" id="paso3">
                            <div class="h2 mb-3 mb-lg-4 d-block">{{ $t('renovar_abono.renovacion_abono', {abono: teatro.texto_abono}) }}</div>
                            <div class="row flex-lg-nowrap">
                                <div class="col-12 col-lg-4" v-if="asiento">
                                    <label class="d-block h5"><span class="altcolor">A</span>. {{ $t('renovar_abono.asiento_anterior') }}</label>
                                    <div class="lightgray-content p-2 p-lg-3 mb-3">
                                        <ul class="info-list list-unstyled w-100">
                                            <li><label>{{ $t('renovar_abono.tipo') }}</label> {{ $t('renovar_abono.asiento_anterior') }}</li>
                                            <li v-if="asiento.region"><label>{{ $t('general.sector') }}:</label> {{ asiento.region }}</li>
                                            <li v-if="asiento.row"><label>{{ $t('general.fila') }}:</label> {{ asiento.row }}</li>
                                            <li v-if="asiento.seat"><label>{{ $t('general.butaca') }}:</label> {{ asiento.seat }}</li>
                                            <li>
                                                <label>{{ $t('renovar_abono.disponibilidad') }}:</label>
                                                <strong v-if="asiento.ocupado != 1 && asiento.region_disponible" class="green">{{ $t('mapa.disponible') }}</strong>
                                                <strong v-else class="text-danger">{{ $t('mapa.no_disponible') }}</strong>
                                            </li>
                                        </ul>

                                        <router-link
                                            v-if="asiento.ocupado != 1 && asiento.region_disponible"
                                            class="button effect-button"
                                            :to="{ name: 'front.abonos.nuevo.index', query: { region_id: asiento.region_id, seat: asiento.seat, row: asiento.row, dni: abonado.dni, n_abonado_antiguo: abonado.n_abonado_antiguo }}"
                                        >
                                            <span>{{ $t('renovar_abono.renovar') }}</span>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-4" v-if="plaza">
                                    <label class="d-block h5"><span class="altcolor">A</span>. {{ $t('renovar_abono.asiento_anterior') }}</label>
                                    <div class="lightgray-content p-2 p-lg-3 mb-3">
                                        <ul class="info-list list-unstyled w-100">
                                            <li><label>{{ $t('renovar_abono.tipo') }}</label> {{ $t('renovar_abono.asiento_anterior') }}</li>
                                            <li><label>{{ $t('general.sector') }}:</label> {{ plaza.region_name ? plaza.region_name : plaza.sector_name }}</li>
                                            <li><label>{{ $t('general.fila') }}:</label> {{ plaza.fila }}</li>
                                            <li><label>{{ $t('general.butaca') }}:</label> {{ plaza.butaca }}</li>
                                            <li>
                                                <label>{{ $t('renovar_abono.disponibilidad') }}:</label>
                                                <strong v-if="plaza.tipos_abonos" class="green">{{ $t('mapa.disponible') }}</strong>
                                                <strong v-else class="text-danger">{{ $t('mapa.no_disponible') }}</strong>
                                            </li>

                                        </ul>
                                        <router-link
                                            v-if="plaza.tipos_abonos"
                                            class="button effect-button"
                                            :to="{ name: 'front.abonos.nuevo.index', query: { region_id: plaza.region_id, plaza_id: plaza.id, dni: abonado.dni, n_abonado_antiguo: abonado.n_abonado_antiguo }}"
                                        >
                                            <span>{{ $t('renovar_abono.renovar') }}</span>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-8" v-if="!puede_cambiar_butaca">
                                    <label class="d-block h5"><span class="altcolor">{{ $t('renovar_abono.no_cambio') }}</span></label>
                                </div>
                                <div class="col-12 col-lg-8" v-else>
                                    <label class="d-block h5"><span class="altcolor">B</span>. {{ $t('renovar_abono.nuevo_asiento') }}</label>
                                    <div class="lightgray-content p-2 p-lg-3 mb-3">
                                        <SvgComponent 
                                            :zonas="zonas" 
                                            :place="recinto" 
                                            @clickZona="cambiarZona"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-else>
                            <div style="height: 100px">
                                <LoaderComponent/>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>
        <section class="padding-vertical-content" v-if="error">
            <div class="container">
                <div class="row">
                    <div class="col-12" v-if="error == 300">
                        <h1>{{ $t('renovar_abono.ya_renovado', {abono: teatro.texto_abono}) }}</h1>
                    </div>
                    <div class="col-12" v-else>

                        <h1>{{ $t('renovar_abono.no_existe', {abonado: teatro.texto_abonado}) }}</h1>
                        <div v-if="configuracion.mensaje_renovacion" v-html="configuracion.mensaje_renovacion"></div>
                        <div v-else style="margin: 20px">
                            {{ $t('renovar_abono.escriba_correo', { email: this.footer.email_incidencias, abonado: teatro.texto_abonado }) }}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import BuscarAbonadoComponent from '@/components/frontend/abonos/renovar/BuscarAbonadoComponent';
    import InformacionAbonadoComponent from '@/components/frontend/abonos/renovar/InformacionAbonadoComponent';
    import SvgComponent from '@/components/svg/SvgComponent';

    export default {
        props: [],
        data() {
            return {
                paso1: true,
                paso2: false,
                paso3: false,
                abonado_search: {
                    dni: null,
                    n_abonado_antiguo: null
                },
                abonado: null,
                asiento: null,
                plaza: null,
                error: false,
                loading: false,
                renovacion: false,
                puede_cambiar_butaca: false,
                zonas: []
            }
        },
        created() {
            if(this.$route.query.n_abonado_antiguo && this.$route.query.dni) {
                this.abonado_search.dni = this.$route.query.dni;
                this.abonado_search.n_abonado_antiguo = this.$route.query.n_abonado_antiguo;
                this.buscarAbonado();
                this.renovacion = 1;
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        },
        methods: {
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        renovacion: 1
                    },
                    tid: this.configuracion.hash_teatro,
                    renovacion: 1
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.index'), params).then(res => {
                    this.zonas = res.data.data;
                    if (this.recinto) {
                        this.getZonasAnexas();
                    } else {
                        this.loading = false;
                    }
                    this.paso3 = true;
                    this.$nextTick(() => {
                        this.$scrollTo('#paso3', 150);
                    });
                });
            },
            getZonasAnexas() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        renovacion: 1
                    },
                    lista_id: this.lista_abonados.id,
                    recinto_id: this.recinto.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.regiones.anexas'), params).then(res => {
                    let anexas = res.data.data;

                    anexas.forEach(zona => {
                        zona.precios = []; 
                        zona.tipos_abonos.forEach(precio => {
                            zona.precios = zona.precios.concat(precio.descuentos);
                        });
                    });
                
                    this.zonas = this.zonas.concat(anexas);
                }).finally(() => this.loading = false);
            },
            buscarAbonado() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.abonado_search.dni,
                        n_abonado_antiguo: this.abonado_search.n_abonado_antiguo
                    },
                    tid: this.configuracion.hash_teatro,
                    dni: this.abonado_search.dni,
                    n_abonado_antiguo: this.abonado_search.n_abonado_antiguo
                }

                const session_id = sessionStorage.getItem('session_id');

                if (session_id) {
                    params.session_id = session_id;
                    params.filters.session_id = session_id;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(res => {
                    this.abonado = res.data.abonado;
                    this.puede_cambiar_butaca = res.data.puede_cambiar_butaca;
                    this.asiento = res.data.asiento;
                    this.plaza = res.data.plaza;

                    if (this.plaza) {
                        this.plaza.tipos_abonos = res.data.tipos_abonos;
                    }

                    if(!this.abonado) {
                        this.error = res.data.message;
                    } else {
                        this.error = false;
                    }
                    this.getZonas();
                    this.loading = false;
                    this.paso2 = true;
                }).catch(error => {
                    this.error = error.response.status;
                    this.loading = false;
                });
            },
            cambiarZona(zona) {
                this.$router.push({ name: 'front.abonos.nuevo.index', query: { region_id: zona.id, dni: this.abonado.dni, n_abonado_antiguo: this.abonado.n_abonado_antiguo }});
            }
        },
        components: {
            BuscarAbonadoComponent, InformacionAbonadoComponent, SvgComponent
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
